module.exports = __webpack_public_path__ + "static/media/NBCNews.4e85f187.png";